"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ADD: 'Add',
  ACTION: 'Action',
  APPROVE: 'Approve',
  APPROVAL: 'Approval',
  APPROVERS: 'Approver(s)',
  APPLICABLE_TO: 'Applicable To',
  ACCESS_DENIED: 'Access denied. User does not have sufficient access to perform this operation',
  BACK_TO_SYS_ADMIN_BUTTON: 'Back To System Administration',
  BRITIVE_VAULT: 'Britive Vault',
  BRITIVE_VAULT_DETAILS: 'Britive Vault Details',
  BRITIVE_VAULT_GOVERNANCE: 'Britive Vault Governance',
  CONFIGURATION: 'Configuration',
  CANCEL: 'Cancel',
  CHARACTERS: 'Characters',
  CLOSE: 'Close',
  CLONE: 'Clone',
  COPY: 'Copy',
  COPY_OF: 'copy_of_',
  COMMENTS: 'Comments',
  DAYS: 'Days',
  DELETE: 'Delete',
  DESCRIPTION: 'Description',
  DESCRIPTION_LENGTH_MAX: 'Description can not be longer than 255 characters.',
  DRAFT: 'Draft',
  DISCARD_CHANGES: 'Discard Changes?',
  DISABLED: 'Disabled',
  DISABLE: 'Disable',
  ENABLED: 'Enabled',
  ENABLE: 'Enable',
  ENCRYPTION_ALGORITHM: 'Encryption Algorithm',
  EDIT: 'Edit',
  FIELD: 'Field',
  FIELDS: 'Fields',
  FILE: 'File',
  OTP_SEED: 'OTP Seed',
  RECOVERY_KEYS: 'Recovery Keys',
  FOR: 'for',
  MIN_ROTATION_INTERVAL: 'Min number of days 1',
  MAX_ROTATION_INTERVAL: 'Max number of days 60',
  MIN_APPROVAL_DAYS: 'Min number of days 1 is required, for Access validity after approval',
  MULTI_LINE: 'Multiline',
  MANAGE: 'Manage',
  NA: 'NA',
  NO: 'No',
  NO_KEEP_CHANGES: 'No, Keep Changes',
  NONE: 'None',
  NO_ACCESS_To_SECRET_MANAGER: "You don't have access to Secret Manager",
  NUMBER_OF_DAY: '1 Day',
  NUMBER_OF_DAYS: '{{days}} Days',
  INPUT_NAME_MAX_CHAR: 'Name must be between 1 and 30 characters',
  IN_DAYS: 'In Days',
  NAME: 'Name',
  OPTIONAL: 'Optional',
  PATH: 'Path',
  PASSWORD_POLICIES: 'Password Policies',
  PASSWORD: 'Password',
  PASSWORD_POLICIES_MODULE: {
    ADD_PASSWORD_POLICY: 'Add Password Policy',
    ADD_PASSWORD_POLICY_FAILURE_MESSAGE: 'The password policy could not be created. {{reason}}.',
    ADD_PASSWORD_POLICY_SUCCESS_MESSAGE: 'The password policy is created.',
    ALLOWED_SPECIAL_CHARACTERS: 'Allowed Special Characters',
    ALLOWED_SPECIAL_CHARACTERS_VALIDATION: 'Please enter the allowed special characters.',
    ALLOWED_SPECIAL_CHARACTERS_TYPE_VALIDATION: 'Please specify allowed special characters in string.',
    ALPHANUMERIC_PASSWORD_LABEL: 'Alphanumeric Password',
    CANCEL_DIALOG_MESSAGE: 'The unsaved changes to the password policy will be discarded.',
    CLONE_POLICY: 'Clone password policy',
    DELETE_PASSWORD_POLICY_DIALOG_MESSAGE: 'The password policy will be deleted permanently.',
    DELETE_PASSWORD_POLICY_DIALOG_TITLE: 'Delete Password Policy?',
    DELETE_PASSWORD_POLICY_FAILURE: 'The Password Policy could not be deleted. {{reason}}.',
    DELETE_PASSWORD_POLICY_FAILURE_MESSAGE: 'The password policy could not be deleted. It is used in one or more secrets.',
    DELETE_PASSWORD_POLICY_SUCCESS: 'The Password Policy was deleted successfully.',
    DELETE_POLICY: 'Delete password policy',
    EDIT_PASSWORD_POLICY: 'Edit Password Policy',
    EDIT_PASSWORD_POLICY_FAILURE_MESSAGE: 'Changes to the password policy could not be saved. {{reason}}.',
    EDIT_PASSWORD_POLICY_SUCCESS_MESSAGE: 'Changes to the password policy are saved.',
    ERROR_SUBMITTING_FORM: 'Error submitting form',
    INVALID_SPECIAL_CHARACTERS: 'Please enter valid special characters',
    LOWER_CASE_LABEL: 'Must include lower case characters (a-z)?',
    MANAGE_PASSWORD_POLICY: 'Manage password policy',
    NO_ACCESS_TO_MANAGE_PASSWORD_POLICY: "You don't have access to manage password policy",
    NO_ACCESS_TO_CLONE_PASSWORD_POLICY: "You don't have access to clone password policy",
    NO_ACCESS_TO_DELETE_PASSWORD_POLICY: "You don't have access to delete password policy",
    MINIMUM_LENGTH: 'Minimum Length',
    MINIMUM_PASSWORD_LENGTH: 'Minimum Password Length',
    MUST_INCLUDE_A_Z: 'Must Include A-Z',
    MUST_INCLUDE_a_z: 'Must Include a-z',
    MUST_INCLUDE_0_9: 'Must Include 0-9',
    MUST_INCLUDE_SPECIAL_CHARACTERS: 'Must Include Special Characters',
    NUMBER_LABEL: 'Must include numbers (0-9)?',
    PASSWORD_LENGTH_VALIDATION: 'Please specify minimum password length in number.',
    PASSWORD_LENGTH_MIN_VALIDATION: 'Please enter valid minimum password length.',
    PASSWORD_POLICY_LOADING_MESSAGE: 'Loading Password Policies Data...',
    PASSWORD_POLICY_DELETE_LOADING_MESSAGE: 'Deleting Password Policy Data...',
    PASSWORD_POLICY_NAME: 'Password Policy Name',
    PASSWORD_POLICY_NAME_VALIDATION: 'Please enter name of the password policy.',
    PASSWORD_POLICY_NAME_EXIST_VALIDATION: 'Password policy name already exist.',
    PASSWORD_POLICY_SEARCH_PLACEHOLDER: 'Search by Password Policy Name',
    PASSWORD_TYPE: 'Password Type',
    PIN_LABEL: 'PIN (only Numbers)',
    PIN_LENGTH_LABEL: 'PIN Length',
    PIN_LENGTH_VALIDATION: 'Please specify pin length in number.',
    PIN_LENGTH_MIN_VALIDATION: 'PIN length must be atleast 1.',
    PIN_MANDATORY_TEXT: '*Only numbers are allowed.',
    RESET_NOTIFICATION_MESSAGE: 'All fields are replaced with saved values.',
    RESET_PASSWORD_POLICY_DIALOG_MESSAGE: 'All fields will be replaced with the saved password policy.',
    RESET_PASSWORD_POLICY_DIALOG_TITLE: 'Reset Password Policy?',
    SAVE_PASSWORD_POLICY_DIALOG_MESSAGE: 'Changes to the password policy will be saved.',
    SAVE_PASSWORD_POLICY_DIALOG_TITLE: 'Save Password Policy?',
    SPECIAL_CHARS_LABEL: 'Must include special characters?',
    UPPER_CASE_LABEL: 'Must include upper case characters (A-Z)?',
    ALLOW_SPECIAL_CHAR: 'Allowed special Characters?',
    VIEW_PASSWORD_POLICY_ERROR_MESSAGE: 'Unable to get Password policy data'
  },
  RESET: 'Reset',
  RESET_ALL_FIELDS: 'Yes, Reset All Fields',
  RESOURCE: 'Resource',
  RESOURCES: 'Resources',
  REJECT: 'Reject',
  SAVE: 'Save',
  SECRETS_MANAGER: 'Secrets Manager',
  SYSTEM_ADMINISTRATION: 'System Administration',
  SYSTEM_ADMINISTRATOR: 'System Administrator',
  STATUS: 'Status',
  SEARCH: 'Search',
  STATIC_SECRETS_TEMPLATE_MODULE: {
    ADD_SECRET: 'Add Secret Template',
    ADD_FIELD: 'Add Field',
    ADD_FIELD_AT_LEAST_ONE: 'Please add at least one field',
    CANCEL_DIALOG_MESSAGE: 'The unsaved changes to the static secret template will be discarded.',
    CANCEL_FIELD_MESSAGE: 'The unsaved changes to the field will be discarded.',
    CLONE_TOOLTIP: 'Clone template',
    DELETE_TOOLTIP: 'Delete template',
    DELETE_FIELD: 'Delete field',
    DISABLED_DELETE_MESSAGE: 'Predefined template can not be deleted',
    DELETE_SECRET: 'Delete Static Secret Template?',
    DELETE_MESSAGE: 'The template will be deleted permanently.',
    DELETE_SUCCESSFULLY: 'The static secret template was deleted successfully.',
    DELETE_FAILED: 'The static secret could not be deleted. {{reason}}',
    DELETE_TEMPLATE_FAILED_MESSAGE: 'The static secret template could not be deleted. It is used in one or more secrets.',
    EDIT_SECRET: 'Edit Secret Template',
    DELETE_LOADING_MESSAGE: 'Deleting static secret template...',
    ENTER_NUMBER: 'Please specify number of days.',
    ENTER_VALID_DAYS: 'Please enter days between 1 to {{ maxSecretRotationInterval }}',
    FORM_SUBMIT_ERROR: 'Error submitting form',
    FIELD_NAME: 'Field Name',
    FIELD_DESCRIPTION: 'Field Description',
    FIELD_TYPE: 'Field Type',
    FIELD_TYPE_LABEL: 'Field type',
    FIELD_NAME_REQ: 'Field name required.',
    FIELD_ADDED: 'Field added in the static secret template.',
    FIELD_REMOVED: 'Field removed successfully.',
    FIELD_DELETE_MESSAGE: 'Field will be removed from the list.',
    FILE_ALREADY_EXISTS: 'File (not available as the field already exists)',
    FILE_DISABLED_OTP_SEED_SELECTED: 'File is disabled as OTP Seed field already exists',
    OTP_SEED_ALREADY_EXISTS: 'OTP Seed (not available as the field already exists)',
    OTP_SEED_DISABLED_FILE_SELECTED: 'OTP Seed is disabled as File field already exists',
    MANAGE_TOOLTIP: 'Manage template',
    NO_ACCESS_TO_MANAGE_SST_TOOLTIP: "You don't have access to manage static secret template.",
    NO_ACCESS_TO_CLONE_SST_TOOLTIP: "You don't have access to clone static secret template.",
    NO_ACCESS_TO_DELETE_SST_TOOLTIP: "You don't have access to delete static secret template.",
    NAME_ENTER: 'Please enter name of the static secret template.',
    NAME_EXIT: 'A Field with the same name already exists.',
    POLICY_HELPER_TEXT: 'Optional. Used for Password field',
    PASSWORD_MANDATORY_TEXT: '*The field will be mandatory and masked on screen.',
    PASSWORD_POLICY: 'Password Policy',
    PASSWORD_ALREADY_EXISTS: 'Password (not available as the field already exists)',
    SELECT_POLICY: 'Select policy',
    SELECT_PASSWORD: 'Please select password policy.',
    STATIC_SECRETS_TEMPLATE: 'Static Secret Templates',
    SECRETS_LOADING: 'Loading static secret templates...',
    SEARCH_SECRET: 'Search by Static Secret Template Name',
    SECRET_TEMPLATE_NAME: 'Secret Template Name',
    SECRET_ROTATION_INTERVAL: 'Secret Rotation Interval (Days)',
    SECRET_ROTATION_INTERVAL_VIEW: 'Secret Rotation Interval',
    SECRET_TEMPLATE: 'Secret Template',
    SECRET_TEMPLATE_CREATED_SUCCESSFULLY: 'Static secret template is created',
    SECRET_TEMPLATE_UPDATED_SUCCESSFULLY: 'The static secret template is updated',
    SECRET_TEMPLATE_FAILED: 'The field could not be created - {{reason}}.',
    SECRET_TEMPLATE_UPDATE_FAILED: 'The field could not be updated - {{reason}}.',
    SINGLE_LINE_CHAR: 'Single line text (256 characters)',
    MULTI_LINE_CHAR: 'Multi line text (5000 characters)',
    IS_MANDATORY: 'Is Mandatory',
    IS_MANDATORY_FIELD: 'Is it a mandatory field?',
    IS_MASKED: 'Is Masked',
    IS_MASKED_FIELD: 'The field needs to be masked on screen?',
    GET_SECRET_ERROR_MESSAGE: 'Unable load data - {{reason}}.',
    LOADING_SECRET_TEMPLATE: 'Loading static secret template...',
    ROTATION_HELPER_TEXT: 'Optional. Specify interval in days for Password field.',
    REMOVE_FIELD: 'Remove Field?',
    RESET_NOTIFICATION_MESSAGE: 'All fields are replaced with saved values.',
    RESET_SECRET_TEMPLATE_DIALOG_MESSAGE: 'All fields will be replaced with the saved static secret template.',
    RESET_SECRET_TEMPLATE_DIALOG_TITLE: 'Reset Static Secret Template?',
    RECOVERY_KEYS_ALREADY_EXISTS: 'Recovery Keys field already exists',
    VIEW_TOOLTIP: 'View field',
    SINGLE_LINE: 'Single Line',
    MULTI_LINE: 'Multi Line'
  },
  CREATE_VAULT_MODULE: {
    BACK_BUTTON: 'Back to Secret Manager',
    CREATE_VAULT_BUTTON: 'Create Britive Vault',
    CREATE_VAULT_LABEL: 'Create a vault to begin!',
    CREATE_VAULT_NAME_VALIDATION: 'Please enter name of the vault.',
    CREATE_VAULT_ROTATION_VALIDATION: 'Please specify number of days.',
    CREATE_VAULT: 'Create Vault',
    CREATE_VAULT_ROTATION_PLACEHOLDER: 'Enter number of days.',
    CREATE_VAULT_ROTATION_NAME: 'Default Vault Key Rotation Interval',
    CREATE_VAULT_ROTATION_INFO_TOOLTIP: 'Interval for automated rotation of the vault key',
    VAULT_MAX_SECRET_ROTATION_INTERVAL_VALIDATION: 'Max secret rotation interval must be a positive number',
    CREATE_VAULT_MAX_SECRET_ROTATION_INTERVAL_VALIDATION: 'Please specify number of days',
    VAULT_MAX_SECRET_ROTATION_INTERVAL_LABEL: 'Max Secret Rotation Interval',
    VAULT_MAX_SECRET_ROTATION_INTERVAL_PLACEHOLDER: 'It will be defaulted to 60 days if kept blank',
    VAULT_MAX_SECRET_ROTATION_INTERVAL_INFO_TOOLTIP: 'Maximum permissible time interval for secret rotation',
    VAULT_MAX_SECRET_ROTATION_INTERVAL_HELPER_TXT: 'In Days',
    CREATE_VAULT_ERROR: 'Error while creating vault',
    CREATE_VAULT_ENCRYPTION_ALGORITHM: 'Please enter algorithm name.',
    VAULT_CREATED_SUCCESSFULLY: 'Vault is created successfully.',
    VAULT_CREATION_FAIL_MESSAGE: 'Previous attempt to create vault has been failed.',
    VAULT_NO_ACCESS_LABEL: "You don't have access to create vault",
    VAULT_DEFAULT_MEDIUM_SETTINGS: 'Notification Settings',
    VAULT_DEFAULT_MEDIUM_LABEL: 'Notification Medium',
    VAULT_DEFAULT_MEDIUM_OPTIONAL: 'Defined at System Administrator/ Global Settings / Notification Mediums',
    VAULT_DEFAULT_MEDIUM_ERROR: 'Please select Notification Medium',
    VAULT_USER_ERROR: 'Please select User',
    VAULT_TAG_ERROR: 'Please select Tag',
    VAULT_CHANNEL_ERROR: 'Please select Channel',
    VAULT_USER_LIST: 'User List',
    VAULT_TAG_LIST: 'Tag List',
    VAULT_CHANNEL_LIST: 'Channel List',
    VAULT_SEARCH_USER: 'Search User',
    VAULT_SEARCH_TAGS: 'Search Tags',
    VAULT_SEARCH_CHANNELS: 'Search Channels'
  },
  VAULT_DETAILS_MODULE: {
    DEFAULT_KEY_ROTATION_INTERVAL: 'Default Vault Key Rotation Interval',
    MAX_SECRET_ROTATION_INTERVAL_LABEL: 'Max Secret Rotation Interval',
    DELETE_VAULT_MSG: 'This will remove all secrets from the vault. The vault will no longer be accessible.',
    DELETE_VAULT: 'Delete Vault?',
    DELETE_VAULT_INPUT_LABEL: 'Please type "DELETE" to confirm',
    LAST_KEY_ROTATION: 'Last Key Rotation/Generation',
    NEXT_KEY_ROTATION: 'Next Key Rotation ',
    ROTATE_VAULT_KEY_TITLE: 'Rotate Vault Key?',
    ROTATE_VAULT_KEY_YES_LABEL: 'Yes, Rotate Vault Key',
    ROTATE_VAULT_KEY_BUTTON: 'Rotate Vault Key',
    VAULT_DELETED_SUCCESSFULLY: 'Vault was deleted successfully.',
    VAULT_DELETION_FAIL_MESSAGE: 'Vault deletion has been failed.',
    VAULT_NOT_CREATED_WARNING: 'Vault is not created yet, please create vault.',
    VAULT_EDIT_TITLE: 'Edit Britive Vault Details',
    VAULT_RESET: 'Reset Vault?',
    VAULT_RESET_MESSAGE: 'All field will be replaced with the saved values.',
    VAULT_RESET_NOTIFICATION: 'All fields are replaced with saved values.',
    VAULT_SAVE_TITLE: 'Save Details?',
    VAULT_SAVE_MESSAGE: 'Changes to the vault will be saved.',
    VAULT_CANCEL_MESSAGE: 'The unsaved changes to the vault will be discarded.',
    VAULT_UPDATED_SUCCESSFULLY: 'Vault is updated successfully.',
    VAULT_UPDATE_FAILED: 'Error while updating vault',
    VAULT_ROTATE_KEY_SUCCESSFULLY: 'Vault key rotation has started',
    VAULT_ROTATE_KEY_FAIL_MESSAGE: 'Could not rotate vault key. {{reason}}.',
    VAULT_ROTATE_DIALOG_MESSAGE: 'This will encrypt all secrets inside vault with new key. While key rotation is in progress, all vault users can continue to view/manage secrets.',
    VAULT_ROTATE_IN_PROGRESS_MESSAGE: 'Vault key rotation is in progress. Vault Properties can not be changed until key rotation is finished. Users can continue to perform operations secrets as usual.'
  },
  VAULT_DETAILS_FETCHING_MESSAGE: 'Fetching vault details...',
  VAULT_DETAILS_FETCHING_ERROR_MESSAGE: 'Unable to fetch vault details. - {{reason}}',
  VAULT_NAME: 'Vault Name',
  JUSTIFICATION: 'Justification',
  YES: 'Yes',
  YES_DELETE: 'Yes, Delete',
  YES_DISABLE: 'Yes, Disable',
  YES_ENABLE: 'Yes, Enable',
  YES_SAVE: 'Yes, Save',
  YES_DISCARD: 'Yes, Discard Without Saving',
  YES_APPROVE: 'Yes, Approve',
  YES_REJECT: 'Yes, Reject',
  LOADING: 'Loading...',
  SECRETS_MODULE: {
    ADD_NEW_FOLDER_MODAL_TITLE: 'Add New Folder',
    ADD_NEW_FOLDER_MODAL_BUTTON_TEXT: 'Add',
    ADD_NEW_FOLDER_MODAL_CANCEL_TEXT: 'Cancel',
    ADD_NEW_FOLDER_REQUIRED_NAME_VALIDATION_MESSAGE: 'Please enter name of the folder',
    APPROVAL_PENDING_TEXT: 'Approval Pending',
    CANCELLED_STATUS: 'Request Withdrawn',
    FOLDER_CREATED_SUCCESSFULLY: 'The folder is created successfully',
    FOLDER_CREATION_FAIL_MESSAGE: '{{reason}}',
    FOLDER_DELETED_SUCCESSFULLY: 'The folder was deleted successfully',
    FOLDER_DELETION_FAIL_MESSAGE: 'Could not delete folder. Please empty folder before deleting.',
    FIELD_IS_REQUIRED: '{{ fieldName }} field is required',
    FIELD_250_CHARS: '{{ fieldName }} field can have maximum 250 characters',
    FIELD_5000_CHARS: '{{ fieldName }} field can have maximum 5000 characters',
    SECRET_DELETED_SUCCESSFULLY: 'The secret was deleted successfully',
    SECRET_DELETION_FAIL_MESSAGE: 'The secret could not be deleted.',
    FOLDER_NAME: 'Folder Name',
    GET_ONE_LEVEL_NODES_SUCCESSFULLY: 'All the Folders are available',
    GET_ONE_LEVEL_NODES_FAIL_MESSAGE: 'Folders could not be fetched',
    GET_ONE_LEVEL_CHILDREN_FAIL_MESSAGE: 'Error getting data',
    CANCEL_MODAL_MESSAGE: 'The changes will not be saved.',
    CANCEL_MODAL_PRIMARY_BTN: 'Yes, Discard Without Saving',
    CANCEL_MODAL_NO_BTN: 'No',
    CANCEL_MODAL_TITLE: 'Discard Changes?',
    DELETE_NODE_MODAL_TITLE: 'Delete Folder?',
    DELETE_NODE_MODAL_MESSAGE: 'The folder will be deleted permanently.',
    DELETE_NODE_MODAL_PRIMARY_BTN: 'Yes, Delete',
    DELETE_NODE_MODAL_NO_BTN: 'No',
    DELETE_SECRET_MODAL_TITLE: 'Delete Secret?',
    DELETE_SECRET_MODAL_MESSAGE: 'The secret will be deleted permanently.',
    ADD_NODE_ACTION_TITLE: 'Add Folder',
    DELETE_NODE_ACTION_TITLE: 'Delete Folder',
    ADD_SECRET_ACTION_TITLE: 'Add Secret',
    DELETE_SECRET_ACTION_TITLE: 'Delete Secret',
    EDIT_SECRET_ACTION_TITLE: 'Edit',
    SECRET_TAB_TITLE: 'Secrets',
    SECRET_DETAILS_TAB_TITLE: 'Details',
    POLICY_TAB_TITLE: 'Policies',
    SECRETS_NAME_HEADER: 'Secret Name',
    SECRETS_DESCRIPTION_HEADER: 'Description',
    SECRETS_ROTATION_PERIOD_HEADER: 'Days to Rotate',
    SECRETS_CATEGORY_HEADER: 'Category',
    SECRETS_TYPE_HEADER: 'Secret Type',
    SECRETS_ACTION_HEADER: 'Action',
    SECRETS_SEARCH_PLACEHOLDER: 'Search by Secret Name',
    POLICIES_SEARCH_PLACEHOLDER: 'Search For Policies',
    ADD_POLICY_BUTTON_TEXT: 'Add Policy',
    ADD_SECRET_BUTTON_TEXT: 'Add Secret',
    SECRET_LOADING_MESSAGE: 'Loading Secrets...',
    SECRET_DELETE_LOADING_MESSAGE: 'Deleting Secret Data...',
    DELETE_SECRET_SUCCESS_MESSAGE: 'The secret was deleted successfully',
    DELETE_SECRET_FAILURE_MESSAGE: 'The secret could not be deleted. {{reason}}',
    MANAGE_TOOLTIP: 'Manage Secret',
    DELETE_SECRET_TOOLTIP: 'Delete Secret',
    DISABLE_DELETE_SECRET_TOOLTIP: 'Secret can not be deleted',
    ERROR_LOADING_SECRETS_LIST: 'Could not load secrets. {{reason}}.',
    SECRET_FOLDER_ALREADY_EXISTS: 'Secret/Folder already exists.',
    WAITING_FOR_APPROVAL: 'Waiting for Approval',
    WAITING_FOR_APPROVAL_PRIMARY_BUTTON: 'Ok',
    WAITING_FOR_APPROVAL_DIALOG_MESSAGE: 'The request is waiting for approval.',
    NOTIFIED_TEXT: 'You will be notified about the status of this request.',
    TRACK_TEXT: 'You can also track this request under the “My Requests” section.',
    VIEW_ACTION: 'View Secret',
    SEND_REQUEST_BUTTON: 'Send Request',
    NEED_APPROVAL: 'Approval is required to view this secret.',
    APPROVAL_REQUEST_SENT: 'This request can be approved by:',
    SENDING_APPROVAL_REQUEST: 'Sending approval request...',
    JUSTIFICATION_TEXT: 'Justification',
    JUSTIFICATION_LENGTH_MAX: 'Justification can not be longer than 255 characters.',
    APPROVAL_REQUIRED_TEXT: 'Approval Required',
    JUSTIFICATION_REQUIRED: 'Justification is required.',
    ERROR_LOADING_SECRET: 'Could not load secret. {{reason}}.',
    ACCESS_REQUEST_SENT_MESSAGE: 'Access request is sent for approval.',
    LOADING_APPROVERS_DETAILS: 'Loading approvers details...',
    VIEW_SECRET: 'View Secret',
    APPROVE_SECRET_ACTION_MSG: '{{actionName}} permission will be granted to {{userName}} for {{resource}}',
    REJECT_SECRET_ACTION_MSG: '{{actionName}} permission will be denied to {{userName}} for {{resource}}',
    NONE_TEXT: 'None',
    UNABLE_TO_DOWNLOAD_FILE: 'An error occurred while loading the file',
    SELECT_OTP_SEED_TYPE: 'Please select the type of OTP Seed',
    OPTIONAL_OTP_FIELD: 'Optional',
    OTP_SEED_ALREADY_EXIST: 'An OTP seed already exists. Please update with a new setup key/QR code only if you wish to replace the existing seed.'
  },
  SECRET_DETAILS_MODULE: {
    EDIT_BUTTON_TEXT: 'Edit',
    DELETE_BUTTON_TEXT: 'Delete',
    NAME_LABEL: 'Secret Name',
    DESCRIPTION_LABEL: 'Description',
    CATEGORY_LABEL: 'Category',
    ACCESS_TYPE_LABEL: 'Access Type',
    TYPE_LABEL: 'Secret Type',
    ROTATION_INTERVAL_LABEL: 'Secret Rotation Interval (Days)',
    LAST_ROTATION_LABEL: 'Last Rotation/Creation',
    NEXT_ROTATION_LABEL: 'Next Rotation',
    USAGE_INSTRUCTIONS_LABEL: 'Usage Instructions',
    CONNECTION_STRING_LABEL: 'Connection String',
    USERNAME_LABEL: 'User Name',
    PASSWORD_LABEL: 'Password',
    SHOW_BUTTON_TEXT: 'Show',
    HIDE_BUTTON_TEXT: 'Hide',
    DETAILS_FAILURE_MESSAGE: 'The details could not be fetched. {{reason}}'
  },
  SECRET_CREATE_MODULE: {
    CANCEL_DIALOG_MESSAGE: 'The unsaved changes to the secret will be discarded.',
    ERROR_SUBMITTING_FORM: 'Error submitting form',
    NAME_LABEL: 'Secret Name',
    DESCRIPTION_LABEL: 'Description',
    DESCRIPTION_HELPER_LABEL: 'Optional',
    CATEGORY_LABEL: 'Category',
    ACCESS_TYPE_LABEL: 'Access Type',
    TYPE_LABEL: 'Secret Type',
    ROTATION_INTERVAL_LABEL: 'Secret Rotation Interval',
    TEMPLATE_DESCRIPTION_LABEL: 'Template Description',
    PASSWORD_POLICY_LABEL: 'Password Policy',
    DETAILS_SUBHEADING: 'Secret Details',
    SAVE_BUTTON_TEXT: 'Save',
    CANCEL_BUTTON_TEXT: 'Cancel',
    SECRET_FOLDER_ALREADY_EXISTS: 'Secret/Folder already exists.',
    SUCCESS_MESSAGE: 'The secret is created.',
    FAILURE_MESSAGE: 'The secret could not be added. {{reason}}.',
    NAME_REQUIRED_MESSAGE: 'Please enter name of the secret.',
    NAME_EXIST_VALIDATION_MESSAGE: 'Secret name already exists.',
    SECRET_TYPE_REQUIRED_MESSAGE: 'Please enter secret type.',
    GENERATE_PASSWORD_FAILURE_MESSAGE: 'Password could not be generated. {{reason}}.',
    PASSWORD_POLICY_ID_NULL_MESSAGE: 'Password policy id is null',
    OPTIONAL_HELPER_TEXT: 'Optional',
    GENERATE_PASSWORD_BUTTON_TEXT: 'Generate',
    CATEGORY_VALUE: 'Static Secret',
    ACCESS_TYPE_VALUE: 'Concurrent (Multiple users can access anytime)',
    LOADING_NODE_DATA: 'Loading Node Data...',
    LOADING_SECRET_DETAILS: 'Loading Secret Details...',
    SEARCH_SECRET_TYPE: 'Search Secret type'
  },
  SECRET_EDIT_MODULE: {
    EDIT_SECRET_TITLE: 'Edit Secret',
    RESET_SECRET_DIALOG_TITLE: 'Reset Secret?',
    RESET_SECRET_DIALOG_MESSAGE: 'All fields will be replaced with the saved secret',
    RESET_SECRET_DIALOG_PRIMARY_BTN_TEXT: 'Yes, Reset All Fields',
    RESET_SECRET_DIALOG_SECONDARY_BTN_TEXT: 'No, Keep Changes',
    EDIT_SECRET_SUCCESS_MESSAGE: 'Changes to the secret are saved.',
    NO_FIELD_CHANGED_MESSAGE: 'No Changes saved.'
  },
  MY_APPROVALS_AND_REQUEST_MODULE: {
    APPROVED_TEXT: 'Approved',
    APPROVALS_LOADING: 'My Approvals Loading',
    APPROVE_REQUEST: 'Approve Request?',
    APPROVAL_STATUS: 'Approval status',
    APPROVAL_PENDING: 'Approval Pending',
    APPROVAL_REQUEST_TOOLTIP: 'Approve Request',
    APPROVED_BY: 'Approved By',
    APPROVED_ON: 'Approved On',
    APPROVERS: 'Approvers',
    CLOSE: 'Close',
    EXPIRED_ON: 'Expired On',
    FETCHING_APPROVALS: 'Fetching approvals details',
    FETCHING_REQUESTS: 'My Requests Loading',
    JUSTIFICATION: 'Justification',
    MANAGE_REQUEST_TOOLTIP: 'Manage Request',
    VIEW_REQUEST_TOOLTIP: 'View Request',
    PERMISSION_GRANTED: 'permission will be granted to',
    PERMISSION_DENIED: 'permission will be denied to',
    PROFILE_CHECKOUT_REQUEST: 'Profile checkout request',
    REQUEST_EXPIRED_TOOLTIP: 'Request Expired',
    REJECT_REQUEST: 'Reject Request?',
    REJECT_REQUEST_TOOLTIP: 'Reject Request',
    REJECTED_STATUS: 'Rejected',
    REQUESTED_ON: 'Requested On',
    REQUESTED_BY: 'Requested By',
    REQUEST_APPROVED: 'The Request is approved',
    REQUEST_REJECTED: 'The Request is rejected',
    REQUEST_NOT_APPROVED: 'Could not approve the request. {{reason}}.',
    REQUEST_NOT_REJECTED: 'Could not reject the request. {{reason}}.',
    REQUEST_DATE: 'Request Date',
    REQUEST_VALIDITY: 'Request Validity',
    REQUEST_WITHDRAWN: 'Request successfully withdrawn.',
    REQUEST_TYPE: 'Request Type',
    CANCELLED_REQUEST: 'Request Withdrawn',
    REJECTED_BY: 'Rejected By',
    REJECTED_ON: 'Rejected On',
    SEARCH_RESOURCE: 'Search by Resource',
    SEARCH_NOT_SUPPORTED: 'Search is not supported on this screen',
    SEARCH_REQUEST: 'Search Request',
    SECRET_VIEW_REQUEST: 'Secret View Request',
    STATUS: 'Status',
    TIMEOUT_STATUS: 'Request Expired',
    MESSAGE_EXPIRED: 'This request has expired due to no action from approvers',
    MESSAGE_APPROVED: 'This request is approved by {{userName}}',
    MESSAGE_REJECTED: 'This request is rejected by {{userName}}',
    APPROVAL_EXPIRED_MESSAGE: 'Validity expired',
    ACCESS_DENIED: 'Access denied',
    YES_WITHDRAW: 'Yes, Withdraw',
    WITHDRAW_REQUEST: 'Withdraw Request',
    WITHDRAW_REQUEST_PROMPT: 'You are about to withdraw the request. Do you want to proceed?'
  },
  POLICIES_MODULE: {
    ACCESS_TYPE: 'Access Type',
    ACCESS_LEVEL: 'Access Level',
    ACCESS_VALIDITY_AFTER_APPROVAL_LABEL: 'Approval Validity',
    ADD_POLICY: 'Add Policy',
    ADD_TAGS: 'Select Tags',
    ALL_USERS: 'All Users',
    ALL_TAGS: 'All Tags',
    ALL_SERVICE_IDENTITIES: 'All Service Identities',
    ALL_TOKENS: 'All Tokens',
    API_TOKENS: 'API Tokens',
    BACK: 'Back',
    CHANNEL_LIST_LABEL: 'Channel List',
    CREATE_EDIT: 'Create, Edit',
    DISABLE_LOADING_MESSAGE: 'Disabling Policy...',
    ENABLE_LOADING_MESSAGE: 'Enabling Policy...',
    POLICY_NAME: 'Policy Name',
    LOADING_POLICIES: 'Loading Policies...',
    LOADING_METADATA: 'Loading Metadata...',
    INPUT_NAME_MAX_CHAR: 'Name must be between 1 and 128 characters',
    NAME_CHAR_VALIDATION: 'Name should only contain alphabets, numbers or special chars: underscore ( _ ) and hyphen ( - )',
    NO_USERS_FOUND: '*No users present in the system',
    NO_TAGS_FOUND: '*No tags present in the system',
    NO_CHANNELS_FOUND: '*No channels present in the notification medium',
    FAILED_LOADING_METADATA: 'Unable to load metadata. - {{reason}}',
    POLICIES_ERROR_LOADING_MESSAGE: 'Unable to load policies. {{reason}}',
    DELETE_POLICY_TOOLTIP: 'Delete policy',
    DISABLED_DELETE_POLICY_TOOLTIP: 'Predefined policy can not be deleted',
    DISABLED_TA_DELETE_TOOLTIP: 'Tenant Admin policy can not be deleted',
    MANAGE_POLICY_TOOLTIP: 'Manage Policy',
    MANAGE: 'Manage',
    DISABLE_TOOLTIP: 'Disable policy',
    ENABLE_TOOLTIP: 'Enable policy',
    END_DATE_TIME_GREATER_THEN_TODAY_VALIDATION: 'End date time should be later than current date time',
    DISABLE_FOR_USER_TOOLTIP: 'Tenant Admin Policy can not be disabled',
    DELETE_POLICY: 'Delete Policy?',
    DELETE_POLICY_CONFIRM_TITLE: 'Delete Policy?',
    DELETE_POLICY_CONFIRM_MESSAGE: 'The policy will be deleted permanently.',
    DELETE_POLICY_SUCCESS_MESSAGE: 'The policy was deleted successfully.',
    DELETE_POLICY_ERROR_MESSAGE: 'The policy could not be deleted. - {{reason}}',
    INCLUDE_HIERARCHY_BELOW_PATH: 'Include all resources in the hierarchy below the resource path?',
    PRE_DEFINED_PERMISSION_VALIDATION: 'Pre-defined permissions are not allowed',
    PROVIDE_RESOURCE_VALIDATION: 'Provide resource for permission',
    PROVIDE_VALID_RESOURCE_VALIDATION: 'Provide valid resource for permission',
    POLICY_CLONE: 'Policy cloned to clipboard.',
    POLICY_JSON_FORMAT: 'Policy in Json Format',
    ROLES_NOT_ALLOWED_VALIDATION: 'Roles are not allowed',
    TOGGLE_POLICY_CONFIRM_TITLE: '{{toggleType}} Policy?',
    TOGGLE_POLICY_CONFIRM_TITLE_DISABLE: 'Disable Policy?',
    TOGGLE_POLICY_CONFIRM_TITLE_ENABLE: 'Enable Policy?',
    TOGGLE_POLICY_CONFIRM_MESSAGE: 'The policy will be {{nextValue}}.',
    TOGGLE_POLICY_CONFIRM_MESSAGE_DISABLE: 'The policy will be disabled.',
    TOGGLE_POLICY_CONFIRM_MESSAGE_ENABLE: 'The policy will be enabled.',
    TOGGLE_POLICY_SUCCESS_MESSAGE: 'The Policy is {{nextValue}}.',
    TOGGLE_POLICY_SUCCESS_MESSAGE_DISABLE: 'The Policy is disabled.',
    TOGGLE_POLICY_SUCCESS_MESSAGE_ENABLE: 'The Policy is enabled.',
    TOGGLE_POLICY_ERROR_MESSAGE: 'The Policy could not be {{nextValue}}. {{reason}}',
    TOGGLE_POLICY_ERROR_MESSAGE_DISABLE: 'The Policy could not be disabled. {{reason}}',
    TOGGLE_POLICY_ERROR_MESSAGE_ENABLE: 'The Policy could not be enabled. {{reason}}',
    VIEW: 'View',
    SEARCH_PLACEHOLDER: 'Search by Policy Name',
    APPROVALS: 'Approvals',
    APPROVERS: 'Approvers',
    APPROVAL_REQUIRED: 'Approval Required?',
    MANAGER_APPROVAL_MANDATORY: 'Manager Approval Mandatory?',
    APPROVER_TYPE: 'Approver Type',
    DELETE_POLICY_ERROR_MESSAGE_WITH_REASON: 'The policy could not be deleted,  {{reason}}.',
    MAX_VALID_TIME_AFTER_APPROVAL_REQUIRED: 'Access validity after approval is required.',
    MAX_VALID_TIME_AFTER_APPROVAL_FORMAT: 'Access validity after approval should be in hours:minutes format',
    MEMBERS_DIALOG_TITLE: 'Policy Will be Disabled!',
    MEMBERS_DIALOG_MESSAGE: 'While saving the changes the policy will be disabled as it does not have any members.',
    MEMBERS_DIALOG_SECONDARY_BUTTON: 'Cancel',
    MEMBERS_DIALOG_PRIMARY_BUTTON: 'Disable policy and save changes',
    LOADING_MEMBERS: 'Loading Members...',
    ADDING_POLICY: 'Adding Policy...',
    ADD_PERMISSION_DUPLICATE: 'The permission could not be added to the list as it already exists.',
    ADD_PERMISSION_SUCCESS: 'The permission is added to the list.',
    CHANNEl_MIN: 'At least one channel is required.',
    CHANNEL_LIST_PLACEHOLDER: 'Search Channels',
    EDIT_POLICY: 'Edit Policy',
    READONLY_POLICY_JSON_MESSAGE: 'Predefined Policies can not be updated through JSON',
    ADD_POLICY_SUCCESS: 'Policy created Successfully.',
    CANCEL_ADD_POLICY: 'The unsaved changes to the policy will be discarded.',
    CLONE_POLICY_TOOLTIP: 'Clone policy',
    EDITING_POLICY: 'Editing Policy...',
    DRAFT_ENABLE_TOOLTIP: 'Draft policy can not be enabled',
    TIME_VALIDATION: 'At least one date/time option must be selected',
    END_DATE_TIME_VALIDATION: 'End date time should be later than start date time',
    END_TIME_VALIDATION: 'End time should be later than start time',
    INLINE_POLICY_SUCCESS_MESSAGE: 'The inline permission is added to the list.',
    INLINE_POLICY_UNIQUE_NAME_MESSAGE: 'An inline permission with same name already exists.',
    IP_ADDRESS_INVALID: 'Invalid IP Address',
    MINUTES: '{{minutes}} Minutes',
    POLICY_CREATED: 'The policy created successfully.',
    POLICY_UPDATE_SUCCESS: 'Policy Updated Successfully.',
    POLICY_IN_JSON_FORMAT: 'Policy in JSON Format',
    POLICY_NOT_CREATED: 'The policy could not be created.',
    ROLE_DELETE_MODAL_MESSAGE: 'The role will be removed from the list.',
    SAVE_POLICY_DIALOG_MESSAGE: 'Changes to the policy will be saved.',
    SAVE_POLICY_DIALOG_TITLE: 'Save Policy?',
    SAVE_AND_ENABLE: 'Save and Enable',
    SAVE_DRAFT: 'Save Draft',
    START_DATE_TIME_MESSAGE: 'Start date time should be in future and before end date time',
    POLICY_NAME_REQUIRED: 'Policy Name is required',
    POLICY_NAME_UNIQUE: 'Policy Name already exists.',
    PERMISSION_NAME_UNIQUE: 'Permission Name already exists.',
    DESCRIPTION_LENGTH_MAX: 'Description can not be longer than 255 characters.',
    DENY: 'Deny',
    USERS_LABEL: 'Users',
    USERS_MIN: 'At least one user is required.',
    GROUPS_LABEL: 'Tags',
    GROUPS_MIN: 'At least one tag is required.',
    HOURS_MINS: 'Hours:Minutes',
    DAYS: 'Days',
    HOURS: "{{hours}} Hours",
    TOKEN_LABEL: 'API Tokens',
    TOKENS_MIN: 'At least one token is required.',
    RESET_EDIT_TITLE: 'Reset Policy Changes?',
    RESET_EDIT_MESSAGE: 'All fields will be replaced with saved policy',
    RESET_EDIT_PRIMARY_BTN: 'Yes, Reset All fields',
    RESET_EDIT_SECONDARY_BTN: 'No, Keep Changes',
    REMOVE_APPROVALS_TITLE: 'Remove Approvals And Step-up Verification?',
    REMOVE_APPROVALS_MESSAGE: "'Deny' policy does not need approvals and step-up verification. Both the tabs will be removed. Data on these tabs will be lost.",
    SERVICE_IDENTITIES_LABEL: 'Service Identities',
    SERVICE_IDENTITIES_MIN: 'At least one service Identity is required.',
    MEMBER_VALIDATION: 'At least one Member is required.',
    NOTIFICATION_MEDIUM_LABEL: 'Notification Medium',
    NOTIFICATION_MEDIUM_MIN: 'At least one notification medium for approvals is required.',
    NOTIFICATION_MEDIUM_PLACEHOLDER: 'Select Notification Medium',
    ROLES_PERMISSION_ONE_OF: 'At least one permission is required.',
    ALLOW: 'Allow',
    APPROVERS_LABEL: 'Approvers',
    APPROVERS_SUB_LABEL: 'Approval from any one is sufficient',
    APPROVERS_PLACEHOLDER: 'Search Approvers',
    APPROVAL_LABEL: 'Approval Required',
    APPROVER_TYPE_LABEL: 'Approver Type',
    APPROVER_TYPE_ONE_OF: 'Approver type can be one of users,tags or channels.',
    APPROVERS_MIN: 'At least one approver is required.',
    APPROVER_TIME_LABEL: 'Maximum time to Approve',
    IP_ADDRESS_LABEL: 'IP Addresses',
    IP_ADDRESS_HELPER_TEXT: 'Specify comma separated IP addresses in CIDR or dotted decimal format',
    IP_ADDRESS_SUB_LABEL: 'Specify comma separated IP addresses in CIDR format',
    IP_ADDRESS_RADIO_LABEL: 'Do you want to specify conditions based on IP address?',
    IP_ADDRESS_REQUIRED: 'IP Address is required',
    TIMEZONE_REQUIRED: 'Timezone is required',
    DATE_TIME_RADIO_LABEL: 'Do you want to specify conditions based on Date/Time?',
    START_DATE_TIME_REQUIRED: 'Start Date-time is required',
    START_DATE_TIME_LABEL: 'Start Date/Time',
    END_DATE_TIME_REQUIRED: 'End Date-time is required',
    END_DATE_TIME_LABEL: 'End Date/Time',
    START_TIME_REQUIRED: 'Start Time and End Time are required',
    START_TIME_VALIDATION: 'Start time should be before end time.',
    START_TIME_LABEL: 'From',
    END_TIME_REQUIRED: 'End Time is required',
    END_TIME_LABEL: 'To',
    SPECIFY_DATE_TIME_LABEL: 'Specify Start and End Date/Time',
    START_AND_END_DATE_TIME: 'Start and End Date/Time',
    DATE_TIME_SCHEDULE: 'Date and Time Schedule',
    SET_TIME_LABEL: 'Set Time Schedule',
    TIMEZONE_LABEL: 'Timezone',
    MAX_APPROVAL_REQUIRED: 'Max approval time is required.',
    MAX_APPROVAL_FORMAT: 'Max approvals should be in hours:minutes format',
    POLICY_JSON_NOT_EMPTY: 'The Policy JSON can not be empty',
    SEARCH_POLICY: 'Search by Policy Name',
    VIEW_POLICY_ERROR_MESSAGE_WITH_REASON: 'Unable to get policy data,  {{reason}}.',
    EDIT_POLICY_ERROR_MESSAGE_WITH_REASON: 'Unable to draft policy data,  {{reason}}.',
    POLICY_JSON_COPIED: 'The policy JSON was copied.',
    POLICY_JSON_EMPTY: 'The Policy JSON was empty.',
    RESOURCE_LABEL: 'Resource',
    USERS: 'Users',
    USER_LIST_LABEL: 'User List',
    USER_LIST_PLACEHOLDER: 'User List',
    TAG_LIST_LABEL: 'Tag List',
    TAG_LIST_PLACEHOLDER: 'Search Tags',
    TAGS: 'Tags',
    SERVICE_IDENTITIES: 'Service identities',
    IP_ADDRESS: 'IP Addresses',
    START_TIME: 'Start Date/Time',
    END_TIME: 'End Date/Time',
    NOTIFICATION_MEDIUM: 'Notification Medium',
    MAXIMUM_TIME: 'Maximum Time to Approve',
    GENERAL: 'General',
    MEMBERS: 'Members',
    GENERIC_CONDITIONS: 'Generic Conditions',
    STEP_UP_VERIFICATION: 'Step-up Verification',
    STEP_UP_VERIFICATION_RADIO_LABEL: 'Require step-up verification?',
    STEP_UP_VERIFICATION_ALWAYS_PROMPT_RADIO_LABEL: 'Remember previous successful Verification?',
    STEP_UP_VERIFICATION_VIEW_LABEL: 'Step-up Verification enabled?',
    STEP_UP_VERIFICATION_ALWAYS_PROMPT_VIEW_LABEL: 'Always prompt for Verification?',
    STEP_UP_VERIFICATION_ALWAYS_PROMPT_RADIO_LABEL_TOOLTIP: 'Verification validity is configured in the step up verification validity settings for your organization.',
    VIEW_ROLE_POLICY_TOOLTIP: 'View role',
    EDIT_PERMISSION_TOOLTIP: 'Edit permission',
    DELETE_PERMISSION_TOOLTIP: 'Delete permission',
    VIEW_PERMISSION_TOOLTIP: 'View permission',
    WARNING_GET_CHANNEL_LIST: 'Unable to fetch all channels {{reason}}',
    YES_REMOVE_APPROVALS: 'Yes',
    NO_ACCESS_TO_DELETE_POLICY: "You don't have access to delete policy",
    UNABLE_TO_FETCH_METADATA: 'Unable to fetch metadata. {{reason}}',
    NO_ACCESS_TO_ADD_POLICY: "You don't have access to add policy on the resource.",
    NO_ACCESS_TO_CLONE_POLICY: "You don't have access to clone policy",
    NO_ACCESS_TO_MANAGE_POLICY: "You don't have access to manage policy",
    NO_ACCESS_TO_ENABLE_POLICY: "You don't have permission to enable the policy",
    NO_ACCESS_TO_DISABLE_POLICY: "You don't have permission to disable the policy",
    CHANNEL_LIST_HELPER_TEXT: "Comma separated list of channels"
  },
  ROLES_MODULE: {
    ACTION_COLUMN: 'Action',
    ACTION_LABEL: 'Actions',
    ACTION_VALIDATION: 'Please select actions',
    ADD_EXISTING_PERMISSION: 'Add Existing Permission',
    ADD_INLINE_NOTIFICATION: 'The inline permission is added to the list.',
    ADD_NEW_PERMISSION: 'Add New Permission',
    ADD_PERMISSION_NOTIFICATION: 'The permission is added to the list.',
    ADD_ROLE: 'Add Role',
    ADD_ROLE_SUCCESS_MESSAGE: 'The role is created.',
    ADD_ROLE_FAILURE_MESSAGE: 'The role could not be created. {{reason}}',
    CANCEL_MODAL_MESSAGE: 'The unsaved changes to the {{entity}} will be discarded.',
    CANCEL_MODAL_PRIMARY_BTN: 'Yes, Discard Without Saving',
    CANCEL_MODAL_TITLE: 'Discard Changes?',
    CLONE_ROLE_TOOLTIP: 'Clone role',
    CONSUMER_LABEL: 'Consumer',
    CONSUMER_PLACEHOLDER: 'Select Consumer',
    CONSUMER_VALIDATIONS: 'Please select consumer',
    DISABLED_DELETE_ROLE_TOOLTIP: 'Predefined role can not be deleted',
    DELETE_INLINE_NOTIFICATION: 'The inline permission is removed from the list.',
    DELETE_MODAL_INLINE_MESSAGE: 'Inline permission will be removed from the list.',
    DELETE_MODAL_PERMISSION_MESSAGE: 'The permission will be removed from the list.',
    DELETE_MODAL_PRIMARY_BTN: 'Yes, Remove',
    DELETE_MODAL_TITLE: 'Remove Permission?',
    DELETE_PERMISSION_NOTIFICATION: 'The permission is removed from the list.',
    DELETE_ROLE_CONFIRM_TITLE: 'Delete Role?',
    DELETE_ROLE_CONFIRM_MESSAGE: 'The role will be deleted permanently.',
    DELETE_ROLE_SUCCESS_MESSAGE: 'The role was deleted successfully.',
    DELETE_ROLE_ERROR_MESSAGE: 'The role could not be deleted. - {{reason}}.',
    DELETE_ROLE_MESSAGE: 'The role could not be deleted. It is used in one or more configurations.',
    DELETE_ROLE_TOOLTIP: 'Delete role',
    DELETE_PERMISSION_TOOLTIP: 'Delete permission',
    DESCRIPTION_HELPER_LABEL: 'Optional',
    DESCRIPTION_LABEL: 'Description',
    EDIT_PERMISSION_TITLE: 'Edit Permission',
    EDIT_ROLE_ERROR_MESSAGE: 'Changes to the role could not be saved. {{reason}}.',
    EDIT_ROLE_SUCCESS_MESSAGE: 'Changes to the role are saved.',
    EDIT_ROLE_TITLE: 'Edit Role',
    INPUT_NAME_MAX_CHAR: 'Name must be between 1 and 64 characters',
    JSON_TEXTAREA_LABEL: 'Role in JSON Format',
    MANAGE_ROLE_TOOLTIP: 'Manage role',
    PERMISSION_LABEL: 'Permissions',
    ROLES_LABEL: 'Roles',
    PERMISSION_LOADING: 'Loading Permission Data...',
    PERMISSION_NAME_VALIDATION: 'Please enter name of the permission.',
    PERMISSION_NAME_LABEL: 'Permission Name',
    PERMISSION_TITLE: 'Permission',
    PERMISSION_VALIDATION: 'Please add at least one permission',
    RESET_MODAL_MESSAGE: 'All fields will be replaced with the saved permission.',
    RESET_MODAL_ROLE_MESSAGE: 'All fields will be replaced with the saved role.',
    RESET_MODAL_PRIMARY_BTN: 'Yes, Reset All Fields',
    RESET_MODAL_SECONDARY_BTN: 'No, Keep Changes',
    RESET_MODAL_TITLE: 'Reset Permission?',
    RESET_MODAL_ROLE_TITLE: 'Reset Role?',
    RESET_NOTIFICATION: 'All fields are replaced with saved values.',
    RESOURCES_HELPER_LABEL: 'Comma separated list of resources',
    RESOURCE_LABEL: 'Resources',
    RESOURCE_VALIDATION: 'Please add resources of the permission.',
    ROLE_JSON_VALIDATION: 'Please enter role in JSON format.',
    ROLE_LABEL: 'Role Name',
    ROLES_LOADING: 'Loading Roles Data...',
    ROLE_NAME: 'Role Name',
    ROLE_NAME_VALIDATION: 'Please enter name of the role.',
    ROLE_NAME_EXIST_VALIDATION: 'Role name already exist.',
    SAVE_INLINE_PERMISSION: 'Changes to the inline permission are saved.',
    SAVE_MODAL_MESSAGE: 'Changes to the inline permission will be saved.',
    SAVE_MODAL_PRIMARY_BTN: 'Yes, Save',
    SAVE_MODAL_ROLE_MESSAGE: 'Changes to the role will be saved.',
    SAVE_MODAL_ROLE_TITLE: 'Save Role?',
    SAVE_MODAL_TITLE: 'Save Permission?',
    SEARCH_PERMISSION_LABEL: 'Search Permission',
    SEARCH_ROLE_NAME_MESSAGE: 'Search by Role Name',
    SOURCE: 'Source',
    CONSUMER: 'Consumer',
    ACTIONS: 'Actions',
    SOURCE_LABEL: 'Source',
    SUBMIT_FORM_ERROR_TITLE: 'Error submitting form',
    SWITCH_TO_FORM: 'Switch to Form',
    SWITCH_TO_FORM_BTN: 'Discard Changes and Switch to Form',
    SWITCH_TO_FORM_HEADER: 'Switch to Form?',
    SWITCH_TO_FORM_MESSAGE: 'Switching to Form mode will discard all changes made in the JSON.',
    SWITCH_TO_JSON: 'Switch to JSON',
    SWITCH_TO_JSON_BTN: 'Discard Changes and Switch to JSON',
    SWITCH_TO_JSON_HEADER: 'Switch to JSON?',
    SWITCH_TO_JSON_MESSAGE: 'Switching to JSON mode will discard all changes made on form.',
    ROLES_CLONE: 'Role clone to clipboard.',
    GET_ROLE_ERROR_MESSAGE: 'Unable load data. - {{reason}}.'
  },
  ACTIONS: 'Actions',
  CONSUMER: 'Consumer',
  COPY_NOTIFICATION_MESSAGE: 'JSON has been copied to clipboard.',
  HOURS: "{{hours}} Hours",
  MAIN: 'main',
  MINUTES: '{{minutes}} Minutes',
  INLINE: 'Inline',
  PRE_DEFINED: 'Predefined',
  POLICIES_LOADING: 'Loading Policy Data...',
  POLICY: 'Policy',
  PERMISSION: 'Permission',
  PERMISSIONS: 'Permissions',
  PERMISSION_NAME: 'Permission Name',
  QR_CODE: 'QR Code',
  ROLE: 'Role',
  ROLES: 'Roles',
  ROLE_NAME: 'Role Name',
  SETUP_KEY: 'Setup Key',
  SOURCE: 'Source',
  VIEW_JSON: 'View JSON',
  VIEW_ENTITY: 'View Entity',
  VIEW_PERMISSION_TOOLTIP: 'View permission',
  SECRETS_GOVERNANCE_MODULE: {
    SECRETS_LOADING: 'Loading Secrets ...',
    SECRET_NAME: 'Secret Name',
    LAST_ROTATED: 'Last Rotated',
    ASSIGNED_IDENTITIES: 'Assigned Identities',
    SEARCH: 'Search by Secret Name',
    IDENTITIES_LOADING: 'Loading Identities ...',
    SEARCH_IDENTITIES: 'Search by Identities Name',
    SEARCH_BY_NAME: 'Search by Name',
    TYPE: 'Type',
    IDENTITY_NAME: 'Identity Name',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    ASSIGNED_SECRETS: 'Assigned Secrets',
    LAST_USED: 'Last Used',
    ASSIGNED_IDENTITIES_TOOLTIP: 'View Assigned Identities',
    TOTAL_SECRETS: 'Total Secrets',
    TOTAL_IDENTITIES: 'Total Identities',
    ASSIGNED_SECRETS_TOOLTIP: 'View Assigned Secrets'
  }
};
exports.default = _default;